module.exports = __webpack_public_path__ + "img/Group 678.a17f2293.png";